import { initMiniLightbox, showMiniLgithbox, configureMiniLightbox } from "./mini-lightbox";

const addImageSource = (imagePath) => {
  //const lightboxElem = document.getElementsByClassName('js-lightboxContent');
  const imgElem = document.querySelector('.js-lightboxImage');
  const htmlContent = document.querySelector('.js-lightboxHTML');

  const testImg=(/\.(gif|jpg|jpeg|tiff|png)$/i).test(imagePath);

  imgElem.setAttribute("src", imagePath);
  if(testImg){
	  htmlContent.style.display= "none";
	  imgElem.style.display= "block";
  }else{
	  const Http = new XMLHttpRequest();
      const url= imagePath;
      Http.open("GET", url);
      Http.send();
      Http.onreadystatechange=()=>{
	  	imgElem.style.display= 'none';
	  	htmlContent.style.display= "block";
      	htmlContent.innerHTML= Http.responseText;
      }
  }
}


const activateImageTag = () => {
  const elemList = document.querySelectorAll('.js-lbImage');
  for(let i= 0;i<elemList.length; i++){
  //elemList.forEach(function(elem) {
	const elem = elemList[i];
    elem.addEventListener("click", function(e) {
    	addImageSource(e.target.getAttribute("data-fullpath"));
    	showMiniLgithbox();
    });
  //});
  }
}

const getNextImagePath = (currentImagePath) => {
  const imageList = document.querySelectorAll('.js-lbImage');

  for (let i = 0; i < imageList.length; i++) {
    const thisPath = imageList[i].getAttribute('data-fullPath');
    if (thisPath === currentImagePath) {
      const nextIndex = i < (imageList.length - 1) ? (i + 1) : 0;
      const nextPath = imageList[nextIndex].getAttribute('data-fullPath');;

      return nextPath;
    }
  }
}

const getPrevImagePath = (currentImagePath) => {
  const imageList = document.querySelectorAll('.js-lbImage');

  for (let i = 0; i < imageList.length; i++) {
    const thisPath = imageList[i].getAttribute('data-fullPath');

    if (thisPath === currentImagePath) {
      const previousIndex = (i > 0) ? (i - 1) : (imageList.length - 1);
      const nextPath = imageList[previousIndex].getAttribute('data-fullPath');;

      return nextPath;
    }
  }
}

const activateNextButton = () => {
  const elem = document.querySelector('.js-lbImage__next');

  elem.addEventListener('click', function() {
    const imageElem = document.querySelector('.js-lightboxImage');

    const nextImagePath = getNextImagePath(imageElem.getAttribute('src'));
    addImageSource(nextImagePath);
  })
}

const activatePrevButton = () => {
  const elem = document.querySelector('.js-lbImage__prev');

  elem.addEventListener('click', function() {
    const imageElem = document.querySelector('.js-lightboxImage');
    const nextImagePath = getPrevImagePath(imageElem.getAttribute('src'));

    addImageSource(nextImagePath);
  })
}

const setupMiniLightbox = () => {
  const config = {
    'class': 'lightboxContainer',
    'content': `
        <div class="lightboxContent js-lightboxContent">
          <div class='js-lightboxContentMain lightboxContentMain'><div class='js-lightboxHTML lightboxHTML'></div></div>
          <img class="js-lightboxImage lightboxImage">
          <a class="imageNavPanel imageNavPanel--left js-lbImage__prev" href="#">
            <i class="fa fa-chevron-circle-left fa-4x"></i>
          </a>
          <a class="imageNavPanel imageNavPanel--right js-lbImage__next" href="#">
            <i class="fa fa-chevron-circle-right fa-4x"></i>
          </a>
          <div class="imageTitle">
            <span>Description of paradise.</span>
          </div>
        </div>
      `
  }
  configureMiniLightbox(config);
}

export const prepareMiniLightBox = () => {
  initMiniLightbox();

  setupMiniLightbox();

  activateImageTag();

  activatePrevButton();

  activateNextButton();
}
